import { lazy } from "react";
import { ScreenType } from "./Login";

const Login = lazy(() => import("./Login"));
const Main = lazy(() => import("./Main"));
const SupportCalls = lazy(() => import("./SupportCalls"));
const SupportCallsMobile = lazy(() => import("./SupportCallsMobile"));
const SupportCall = lazy(() => import("./SupportCall"));
const NewSupportCall = lazy(() => import("./NewSupportCall"));
const ReportDetails = lazy(() => import("./ReportDetails"));
const NewTask = lazy(() => import("./NewTask"));
const TasksMain = lazy(() => import("./TasksMain"));
const Task = lazy(() => import("./Task"));
const Customers = lazy(() => import("./Customers"));
const MonthReports = lazy(() => import("./MonthReports"));
const NewConnection = lazy(() => import("./NewConnection"));
const ReportDetailMobile = lazy(() => "./ReportDetailMobile");
export {
  Main,
  Login,
  SupportCalls,
  SupportCallsMobile,
  SupportCall,
  NewSupportCall,
  ReportDetails,
  NewTask,
  TasksMain,
  Task,
  ScreenType,
  Customers,
  MonthReports,
  NewConnection,
  ReportDetailMobile,
};
